import { FileSpreadsheet, FileText, Scale } from "lucide-react";
import { PreviewButton } from "@/components/PdfPreview";
import { download } from "@/lib/api";
import { money } from "@/lib/fmt";
import { Button } from "@/components/ui/button";

const pc = (a, b) => (b ? `${((a / b) * 100).toFixed(2)}%` : "0.00%");

export const MarginDiff = ({ id, no, items, currency }) => {
  const rows = items.map((it) => {
    const qty = Number(it.qty || 0);
    return { name: it.name, qty, unit: it.unit, mci: Number(it.ref_cost || 0) * qty, par: Number(it.unit_cost_q || 0) * qty, usr: Number(it.line_total || 0) };
  });
  const t = rows.reduce((a, r) => ({ mci: a.mci + r.mci, par: a.par + r.par, usr: a.usr + r.usr }), { mci: 0, par: 0, usr: 0 });
  const m = (v) => money(v, currency);
  const fname = `Selisih-Margin-${no || id}`.replace(/\//g, "-");
  const Cells = ({ r }) => (<>
    <td className="text-right">{m(r.mci)}</td><td className="text-right">{m(r.par)}</td>
    <td className="text-right text-emerald-700">{m(r.par - r.mci)} <span className="text-[11px] font-semibold text-slate-600">{pc(r.par - r.mci, r.par)}</span></td>
    <td className="text-right">{m(r.usr)}</td>
    <td className="text-right text-blue-700">{m(r.usr - r.par)} <span className="text-[11px] font-semibold text-slate-600">{pc(r.usr - r.par, r.usr)}</span></td>
  </>);
  return (
    <div className="card-premium p-6 fade-up" data-testid="margin-diff-panel">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h3 className="flex items-center gap-2 font-heading text-lg font-semibold"><Scale className="h-5 w-5 text-blue-800" />Laporan Selisih Margin</h3>
        {id && (
          <div className="flex gap-2">
            <Button size="sm" variant="outline" className="bg-white" onClick={() => download(`/costings/${id}/margin-report`, { fmt: "xlsx" }, `${fname}.xlsx`)} data-testid="margin-diff-xlsx-btn"><FileSpreadsheet className="mr-1 h-4 w-4 text-emerald-700" />Excel</Button>
            <PreviewButton size="sm" url={`/costings/${id}/margin-report`} params={{ fmt: "pdf" }} filename={`${fname}.pdf`} title="Perbandingan Margin" testId="margin-diff-preview-btn" />
            <Button size="sm" variant="outline" className="bg-white" onClick={() => download(`/costings/${id}/margin-report`, { fmt: "pdf" }, `${fname}.pdf`)} data-testid="margin-diff-pdf-btn"><FileText className="mr-1 h-4 w-4 text-rose-600" />PDF</Button>
          </div>
        )}
      </div>
      <div className="overflow-x-auto rounded-lg border border-slate-200">
        <table className="tbl w-full text-xs font-num" data-testid="margin-diff-table">
          <thead><tr><th>Item</th><th className="text-right">Cost MCI</th><th className="text-right">Harga Partner</th><th className="text-right">Margin MCI → Partner</th><th className="text-right">Harga User</th><th className="text-right">Margin Partner → User</th></tr></thead>
          <tbody>
            {rows.map((r, i) => <tr key={i} data-testid={`margin-diff-row-${i}`}><td className="font-sans">{r.name} <span className="text-slate-400">× {r.qty.toLocaleString("id-ID")} {r.unit}</span></td><Cells r={r} /></tr>)}
            <tr className="bg-blue-50 font-semibold" data-testid="margin-diff-total"><td className="font-sans">TOTAL</td><Cells r={t} /></tr>
          </tbody>
        </table>
      </div>
      <p className="mt-2 text-[11px] text-slate-400">Harga Partner diambil saat duplikat. Simpan kalkulasi agar export memakai angka terbaru.</p>
    </div>
  );
};
